import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row"]
  static values = { url: String }

  connect() {
    this.dragging = null
  }

  // Handle-only drag start (your handle element has draggable + data-action)
  dragstart(event) {
    const handle = event.target.closest("[data-sortable-handle='true']")
    if (!handle) return

    const row = handle.closest("[data-sortable-table-target='row']")
    if (!row) return

    // Visual feedback
    handle.style.cursor = "grabbing"
    row.classList.add("opacity-50")

    this.dragging = row

    const id = this.rowId(row)
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", String(id))
  }

  dragend(event) {
    const handle = event.target.closest("[data-sortable-handle='true']")
    if (handle) handle.style.cursor = "grab"

    if (this.dragging) this.dragging.classList.remove("opacity-50")
    this.dragging = null
  }

  dragover(event) {
    if (!this.dragging) return

    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const overRow = event.target.closest("[data-sortable-table-target='row']")
    if (!overRow || overRow === this.dragging) return

    const rect = overRow.getBoundingClientRect()
    const after = event.clientY > rect.top + rect.height / 2

    const parent = overRow.parentNode
    if (after) parent.insertBefore(this.dragging, overRow.nextSibling)
    else parent.insertBefore(this.dragging, overRow)
  }

  drop(event) {
    if (!this.dragging) return
    event.preventDefault()

    this.syncPositionInputs()
    this.saveOrder()
  }

  syncPositionInputs() {
    // Keeps the visible position inputs aligned with the row order (nice UX)
    this.rowTargets.forEach((row, idx) => {
      const input = row.querySelector("input[name*='[position]']")
      if (input) input.value = String(idx + 1)
    })
  }

  async saveOrder() {
    if (!this.hasUrlValue) return

    const order = this.rowTargets
      .map((row) => this.rowId(row))
      .filter((id) => id)

    const token = document.querySelector("meta[name='csrf-token']")?.content

    try {
      await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": token,
          "Accept": "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({ order }),
      })
    } catch (e) {
      console.error("Failed to persist order:", e)
    }
  }

  // Support either data-id="123" OR data-sortable-id="123"
  rowId(row) {
    return row.dataset.id || row.dataset.sortableId
  }
}
